function mulberryInit() {
  let currentVariant = window.meta.product.variants[0];
  let product;
  let pdpModal;
  let pdpInline;
  let selectedWarranty;
  let allOffers;

  function updateCurrentVariant() {
    const newVar = document.querySelector(
      '.variant-wrapper  input[type="radio"]'
    )?.value;
    currentVariant = window.meta.product.variants.find(
      (i) => i.public_title == newVar
    );
    if (!currentVariant) {
      currentVariant = window.meta.product.variants[0];
    }
    updateMulberryOffers();
    return currentVariant;
  }

  async function updateMulberryOffers() {
    if (!product) return;

    const offers = await window.mulberry.core.getWarrantyOffer({
      detail: product.product,
      title: product.product.title,
      id: product.product.id,
      price: (currentVariant.price / 100).toString(),
    });
    pdpInline.updateOffer(offers);
    pdpModal.updateOffer(offers);
  }

  function getOffers() {
    return window.mulberryShop
      .getProductData(window.mulberryShop.getProductUrl())
      .then((productData) => {
        product = productData;
        return window.mulberry.core.getWarrantyOffer({
          detail: productData.product,
          title: productData.product.title,
          id: productData.product.id,
          price: (currentVariant.price / 100).toString(),
        });
      });
  }

  let initialSelectedIndex = -1;
  getOffers().then(async (offers) => {
    const currentCart = window.mulberryShop.cart.getCart();
    let offerVar = [];
    for (let offer of offers) {
      let result = await mulberryShop.getWarrantyVariant(offer);
      offerVar.push(result);
    }

    console.log("mulberry offers", offers);
    allOffers = offers;
    pdpInline = await mulberry.inline.init({
      offers,
      settings: mulberry.core.settings,
      selector: "#mulberry-inline-target",
      onWarrantyToggle: (warranty) => {
        if (warranty.isSelected) {
          selectedWarranty = warranty.offer;
        } else {
          selectedWarranty = null;
        }
      },
    });

    pdpModal = await mulberry.modal.init({
      offers,
      settings: mulberry.core.settings,
      onWarrantySelect: async (warranty) => {
        const variant = updateCurrentVariant();
        // mulberryShop.selectedVariantId = variant.id;
        const result = await mulberryShop.getWarrantyVariant(warranty);
        await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {
          title: product.product.title,
        });
        mulberry.modal.close();
        //   document.getElementById("mulberry-submit").click();
      },
      onWarrantyDecline: () => {
        mulberry.modal.close();
        //   document.getElementById("mulberry-submit").click();
      },
    });
  });

  document.querySelectorAll(".js-variant-slide").forEach((item) => {
    item.addEventListener("click", (event) => {
      updateCurrentVariant();
    });
  });

  const submitButton = document.getElementById("add-to-cart");

  submitButton.addEventListener("click", async (e) => {
    if (window && window.mulberryShop) {
      if (!allOffers || !pdpModal) return;
      e.stopImmediatePropagation();
      if (selectedWarranty) {
        window.mulberry.inline.setLoading(true);
        const variant = updateCurrentVariant();
        mulberryShop.selectedVariantId = variant.id;
        const result = await mulberryShop.getWarrantyVariant(selectedWarranty);
        await mulberryShop.addWarrantyToCart(result.shopify_variant_id, {
          title: product.product.title,
        });
        window.mulberry.inline.setLoading(false);
      } else {
        pdpModal.open();
      }
    }
  });

  updateCurrentVariant();
}

async function removeAndSyncWarranties(reload = false) {
  await fetch("/cart.js", {
    credentials: "same-origin",
    method: "GET",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "XMLHttpRequest", // This is needed as currently there is a bug in Shopify that assumes this header
    },
  }).then(function (cart) {
    cart.json().then(function (firstCart) {
      mulberryShop
        .removeDetachedWarranty(firstCart) // Remove Warranties First
        .then((newCart) => {
          mulberryShop.cart
            .syncQuantities(newCart) // Sync Quantities Second
            .then((content) => {
              const d = new theme.CartDrawer();
              d.cartForm.buildCart();
            });
        });
    });
  });
}

document.addEventListener("mulberry-shopify:loaded", () => {
  if (window.meta.product) {
    mulberryInit();
  }
  removeAndSyncWarranties();
  setupAjaxListeners();
  setupFetchListeners();
  addCartEventListeners();
});

function setupAjaxListeners() {
  // Set up listeners to fire the pixel if/when the user peforms specific actions that trigger ajax requests.
  // Since we cant create globals we test for the XMLHttpRequest overwrite
  if (typeof XMLHttpRequest.prototype.mbOpen === "undefined") {
    // We mock fetch() in order to determine if we should mock then() as well
    var mbFetch = fetch;
    fetch = function () {
      var url = arguments[0];
      var body = "";
      if (arguments.length > 1 && typeof arguments[1].body !== "undefined") {
        body = arguments[1].body;
      }
      var promise = mbFetch.apply(this, arguments);
      if (url && url.indexOf("cart/change") !== -1) {
        //If its a product being added to cart we add a function to track it
        promise = promise.then(function (response) {
          if (response.ok) {
            //trackAjaxAddToCart(body, response.clone().json());
          }
          return response;
        });
      }
      return promise;
    };
  }
  if (typeof XMLHttpRequest.prototype.mbOpen === "undefined") {
    // We mock the XMLHttpRequest open method in order to determine if we should mock the send method
    XMLHttpRequest.prototype.mbOpen = XMLHttpRequest.prototype.open;
    XMLHttpRequest.prototype.open = function () {
      var url = arguments[1];
      if (
        url &&
        (url.includes("cart/change") ||
          url.includes("cart/add") ||
          url.includes("cart/update"))
      ) {
        // We mock the instance's send method if the request is to the "add to the cart" url.
        this.mbSend = this.send;
        this.send = function (value) {
          try {
            if (value) {
              var self = this; // The xhttp request object

              var trackOnSuccess = function () {
                if (self.readyState === 4 && self.status === 200) {
                  if (self.responseURL !== undefined) {
                    if (self.responseURL.includes("cart/add")) {
                      console.log("shopify:cart-add");
                      addCustomEvent = new CustomEvent("shopify:cart-add");
                      document.dispatchEvent(addCustomEvent);
                    }
                    if (self.responseURL.includes("cart/update")) {
                      // console.log("shopify:cart-update");
                      // updateCustomEvent = new CustomEvent(
                      //   "shopify:cart-update"
                      // );
                      // document.dispatchEvent(updateCustomEvent);
                    }
                  }
                }
              };

              if (typeof self.addEventListener !== "undefined") {
                self.addEventListener("readystatechange", trackOnSuccess);
              } else {
                if (
                  typeof self.onreadystatechange !== "undefined" &&
                  self.onreadystatechange !== null
                ) {
                  // If the xhttp object already has an onreadystatechange callback, make sure we preserve it.
                  self.mbOnreadystatechange = self.onreadystatechange;
                  self.onreadystatechange = function () {
                    self.mbOnreadystatechange();
                    trackOnSuccess();
                  };
                } else {
                  // If there is no onreadystatechange callback, we can safely set it.
                  self.onreadystatechange = trackOnSuccess;
                }
              }
            }
          } catch (e) {
            // if something goes wrong tracking the addToCart,
            // we just ignore it and prevent the website from breaking.
            console.log(e);
          }
          this.mbSend(value);
        };
      }
      this.mbOpen.apply(this, arguments);
    };
  }
}

function setupFetchListeners() {
  const { fetch: origFetch } = window;
  window.fetch = async (...args) => {
    const response = await origFetch(...args);
    let requestUrl = args[0];
    console.log("setupFetchListeners",requestUrl);
    if (requestUrl.includes("cart/change") || requestUrl.includes("cart/add") || requestUrl.includes("cart/update")) {
      response
        .clone()
        .json()
        .then((body) => {
          if (requestUrl.includes("cart/add")) {
            console.log("setupFetchListeners shopify:cart-add");
            fetchAddCustomEvent = new CustomEvent("shopify:cart-add");
            document.dispatchEvent(fetchAddCustomEvent);
          } else if (requestUrl.includes("cart/change")) {
            console.log("setupFetchListeners shopify:cart-change");
            fetchChangeCustomEvent = new CustomEvent("shopify:cart-change");
            document.dispatchEvent(fetchChangeCustomEvent);
          }else {
            if (requestUrl.includes("cart.php")) {
              fetchCartCustomEvent = new CustomEvent("shopify:cart-page");
              document.dispatchEvent(fetchCartCustomEvent);
            }
          }
        })
        .catch((err) => console.error(err));
    }
    return response;
  };
}

function addCartEventListeners() {
  document.addEventListener("shopify:cart-change", function () {
    removeAndSyncWarranties();
  });

  document.addEventListener("shopify:cart-add", async function () {
    removeAndSyncWarranties();
  });

  document.addEventListener("shopify:cart-page", async function () {
    removeAndSyncWarranties();
  });

  document.addEventListener("mulberry-shopify:warranty-added", function () {
    removeAndSyncWarranties();
  });
}
